import { useEffect, useState } from "react";
import { Box } from "lucide-react";
import { api, API } from "../../lib/api";
import Reveal from "./Reveal";

export default function PairsSection() {
  const [pairs, setPairs] = useState(null);
  useEffect(() => {
    api.get("/pairs").then((r) => setPairs(r.data)).catch(() => setPairs([]));
  }, []);
  const real = pairs && pairs.length > 0;

  return (
    <section className="pairs-section section-wrap" id="work" data-testid="pairs-section">
      <Reveal className="section-heading">
        <div><p className="eyebrow">Proof, not promises</p><h2>Real photo.<br /><span>Real statue.</span></h2></div>
        <p className="heading-note">Every piece is shown next to the original photo — judge our accuracy and precision yourself.</p>
      </Reveal>
      <div className="pairs-grid" data-testid="pairs-grid">
        {real && pairs.map((p, i) => (
          <Reveal key={p.id} delay={(i % 2) * 0.1} className="pair-card">
            <div className="pair-images">
              <figure><img src={`${API}/files/${p.real_file_id}`} alt={`${p.title} — original photo`} loading="lazy" /><figcaption>Photo</figcaption></figure>
              <figure><img src={`${API}/files/${p.print_file_id}`} alt={`${p.title} — 3D printed statue`} loading="lazy" /><figcaption>Printed</figcaption></figure>
            </div>
            <div className="pair-title"><strong>{p.title}</strong><span>PLA &middot; hand-finished</span></div>
          </Reveal>
        ))}
        {pairs !== null && !real && [0, 1].map((i) => (
          <Reveal key={i} delay={i * 0.1} className="pair-card">
            <div className="pair-images">
              <figure><div className="img-placeholder pair-empty"><Box size={30} strokeWidth={1.5} /><span>Photo</span></div></figure>
              <figure><div className="img-placeholder pair-empty"><Box size={30} strokeWidth={1.5} /><span>Printed</span></div></figure>
            </div>
            <div className="pair-title"><strong>Comparison coming soon</strong><span>PLA &middot; hand-finished</span></div>
          </Reveal>
        ))}
      </div>
      {pairs !== null && !real && <p className="gallery-note" data-testid="pairs-sample-note">The owner is adding real photo-vs-print comparisons — check back soon.</p>}
    </section>
  );
}
